interface LoginModelOptions {
    cpfCnpj?: string;
    senha?: string;
    correlationId?: string;
    tokenOTP?: string;
    sendBy?:string;
}

export class LoginModel {
    cpfCnpj: string;
    senha: string;
    correlationId: string;
    tokenOTP: string;
    sendBy:string;

    constructor(options: LoginModelOptions = {}){
        this.cpfCnpj = options.cpfCnpj;
        this.senha = options.senha;
        this.correlationId = options.correlationId;
        this.tokenOTP = options.tokenOTP;
        this.sendBy = options.sendBy;
    }
}
